import React from "react";
import * as Yup from "yup";
import { observer } from "mobx-react";
import Http from "services/Http";
import {
  Row,
  Col,
  Panel,
  DataTableColumn,
  DataTable,
  Form,
  TextBox,
  Button,
  FormState,
  Checkbox,
} from "@countysuite/ui";
import appsettings, {
  AppSetting,
} from "pages/SystemSettings/AppSettings/appsettings";
import { BasePage } from "pages/BasePage";

interface Props {}
interface State {
  selectedAppSetting: AppSetting;
}

function newAppSetting(): AppSetting {
  return {
    name: "",
    category: "",
    dataType: "",
    description: "",
    itemValue: "",
  };
}

@observer
export class AppSettingsPage extends React.Component<Props, State> {
  state: State = {
    selectedAppSetting: newAppSetting(),
  };

  componentDidMount() {
    this.fetchAppSettings();
    //this.fetchRuleDefinitions();
  }

  fetchAppSettings = async () => {
    const res = await Http.get<any>({
      url: "SystemSettings/GetApplicationSettings",
      waitMessage: "Fetching app settings, please wait...",
    });

    if (res.success) {
      appsettings.load(res.appSettings);
    }
  };

  postAppSetting = async (e: any) => {
    if (!this.state.selectedAppSetting.itemValue) {
      alert("Please enter a value!");
    }

    const res = await Http.post<any>({
      url: "SystemSettings/UpdateApplicationSetting",
      data: {
        name: this.state.selectedAppSetting.name,
        itemValue: this.state.selectedAppSetting.itemValue,
      },
      waitMessage: `Saving ${this.state.selectedAppSetting.name}, please wait.`,
    });

    if (res.success) {
      await this.fetchAppSettings();
      this.setState({ selectedAppSetting: newAppSetting() });
    }
  };

  handleAppSettingChange = (e: any) => {
    let { name, value, checked, type } = e.target;
    const { dataType } = this.state.selectedAppSetting;
    if (dataType === "bit" && type === "checkbox") {
      value = checked ? "1" : "0";
    }
    //TODO: if the form gets split into its own component, we can remove the deep nesting of state.
    this.setState((prevState) => {
      const newState = { ...prevState };
      newState.selectedAppSetting = {
        ...prevState.selectedAppSetting,
        [name]: value,
      };
      return newState;
    });
  };

  appSettingsColumns: DataTableColumn<AppSetting>[] = [
    {
      Header: "Name",
      accessor: "name",
      width: 300,
    },
    {
      Header: "Current Value",
      accessor: "itemValue",
      width: 150,
    },
    {
      Header: "Description",
      accessor: "description",
    },
  ];

  appSettingFormValidation = Yup.object().shape({
    name: Yup.string().required("Please select an application setting."),
    itemValue: Yup.string().min(1, "Please enter a value."),
  });

  render() {
    let itemValueField: any = (
      <TextBox
        label="Current Value"
        name="itemValue"
        readOnly={!this.state.selectedAppSetting.name}
        value={this.state.selectedAppSetting.itemValue}
        onChange={this.handleAppSettingChange}
      />
    );
    const { dataType } = this.state.selectedAppSetting;
    if (dataType === "bit") {
      itemValueField = (
        <div style={{ minHeight: "40px" }}>
          <Checkbox
            name="itemValue"
            checked={this.state.selectedAppSetting.itemValue === "1"}
            onChange={this.handleAppSettingChange}
          >
            <strong>Enable?</strong>
          </Checkbox>
        </div>
      );
    }
    return (
      <BasePage>
        <Row>
          <Col xs={12}>
            <Panel title="Application Settings">
              <div>
                <Form
                  name="selectedAppSetting"
                  values={this.state.selectedAppSetting}
                  onSubmit={this.postAppSetting}
                  validationSchema={this.appSettingFormValidation}
                >
                  {(formProps: FormState) => (
                    <>
                      <Row>
                        <Col sm={12} md={6}>
                          <TextBox
                            label="Name"
                            readOnly
                            name="name"
                            value={this.state.selectedAppSetting.name}
                          />
                        </Col>
                        <Col sm={12} md={3}>
                          <TextBox
                            label="DataType"
                            readOnly
                            name="dataType"
                            value={this.state.selectedAppSetting.dataType}
                          />
                        </Col>
                        <Col sm={12} md={3}>
                          <TextBox
                            label="Category"
                            readOnly
                            name="category"
                            value={this.state.selectedAppSetting.category}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          <TextBox
                            label="Description"
                            readOnly
                            name="description"
                            value={this.state.selectedAppSetting.description}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12} md={6}>
                          {itemValueField}
                        </Col>
                        <Col sm={12} md={6}>
                          <div
                            className="pull-right"
                            style={{ marginTop: "17px" }}
                          >
                            <Button
                              type="submit"
                              color="success"
                              disabled={
                                !this.state.selectedAppSetting.name ||
                                !this.state.selectedAppSetting.itemValue
                              }
                            >
                              Update Setting
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}
                </Form>
              </div>

              <div className="full-width">
                <DataTable
                  filterable
                  data={appsettings.all}
                  columns={this.appSettingsColumns}
                  isRowSelected={(row: AppSetting) =>
                    row.name === this.state.selectedAppSetting.name
                  }
                  onRowClick={(currentRow: AppSetting) =>
                    this.setState({ selectedAppSetting: currentRow })
                  }
                />
              </div>
            </Panel>
          </Col>
        </Row>
      </BasePage>
    );
  }
}
